import React from 'react';

// Styles & Assets
import styles from './ScoreRule.module.css';
import { RxCross1 } from 'react-icons/rx';

// Components
import ColorSelector from '../../UI/ColorSelector/ColorSelector';
import InputSelect from '../../UI/InputSelect/InputSelect';
import Input from '../../UI/Input/Input';

// Language
import { useTranslation } from 'react-i18next';

// Constants
import { OPTIONS_COMPARISON } from '../../../data/ConstantsScores';

// Interfaces
import { IScoreRule } from '../../../interfaces/Score';
import { OptionsSelect } from '../../../interfaces/Input';
import { ScoreRuleDispatch } from '../../../interfaces/Reducers';
interface Props {
    rule: IScoreRule
    dispatchScoreRules: React.Dispatch<ScoreRuleDispatch>
    error: string | undefined
}

const ScoreRule: React.FC<Props> = ({ rule, dispatchScoreRules, error }) => {

    const { t } = useTranslation();

    const handleClickColor = (id: number) => {
        const color_alert = OPTIONS_COLOR_SELECTOR.find(color => color.id === id)?.color;
        if (color_alert !== undefined) dispatchScoreRules({ type: 'CHANGE_COLOR', id: rule.id, color_alert });
    };

    const handleChangeComparison = (option: OptionsSelect) => {
        const comparison = OPTIONS_COMPARISON.find(c => c.id === option.id)?.name;
        if (comparison !== undefined) dispatchScoreRules({ type: 'CHANGE_COMPARISON', id: rule.id, comparison });
    };

    const handleChangeValue = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value.trim() === '' ? NaN : Number(e.target.value);
        dispatchScoreRules({ type: 'CHANGE_VALUE', id: rule.id, value });
    };

    const deleteRule = () => dispatchScoreRules({ type: 'DELETE_RULE', id: rule.id });

    const OPTIONS_COLOR_SELECTOR: { id: number, color: IScoreRule['color_alert'] }[] = [
        { id: 0, color: '#009e03' },
        { id: 1, color: '#f8b133' },
        { id: 2, color: '#ff6d00' },
        { id: 3, color: '#ff0000' },
    ];


    return (
        <div>
            <div className={`${styles.ruleContainer} ${error ? styles.ruleError : ''}`}>
                <button className={styles.cross} onClick={deleteRule}>
                    <RxCross1 />
                </button>
                <div style={{ width: '48px' }}>
                    <ColorSelector
                        options={OPTIONS_COLOR_SELECTOR}
                        defaultColor={rule.color_alert}
                        onClick={handleClickColor}
                    />
                </div>
                <p>{t('global_value_is')}</p>
                <div style={{ width: '60px' }}>
                    <InputSelect
                        options={OPTIONS_COMPARISON}
                        onChange={handleChangeComparison}
                        value={rule.comparison}
                        label=''
                        simpleStyles
                    />
                </div>
                <p>{t('than')}</p>
                <div style={{ width: '60px' }}>
                    <Input
                        type='number'
                        defaultValue={Number.isNaN(rule.value) ? '' : rule.value}
                        onChange={handleChangeValue}
                    />
                </div>
            </div>
            {error && <p className='errorMsg'>{t(error)}</p> }
        </div>
    );
};

export default ScoreRule;